import React from 'react';
import { Box, Button, Container, Typography, Paper } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home as HomeIcon } from '@mui/icons-material';

const NotFound = ({ title = 'Page not found', message }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const defaultMessage = `We could not find anything at ${location.pathname || 'this address'}.`;

  return (
    <Box
      sx={{
        minHeight: '60vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        py: 6,
        px: 2,
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={2}
          sx={{
            p: { xs: 3, sm: 5 },
            textAlign: 'center',
            borderRadius: 3,
            border: '1px solid #e2e8f0',
          }}
        >
          <Typography
            variant="h1"
            sx={{
              fontWeight: 800,
              fontSize: { xs: '4rem', sm: '5rem' },
              lineHeight: 1,
              color: '#DC2626',
              mb: 1,
            }}
          >
            404
          </Typography>
          <Typography variant="h5" component="h1" gutterBottom sx={{ fontWeight: 600 }}>
            {title}
          </Typography>
          <Typography color="text.secondary" sx={{ mb: 3 }}>
            {message || defaultMessage}
          </Typography>
          <Button
            variant="contained"
            size="large"
            startIcon={<HomeIcon />}
            onClick={() => navigate('/', { replace: true })}
            sx={{
              background: 'linear-gradient(135deg, #DC2626 0%, #991B1B 100%)',
              '&:hover': {
                background: 'linear-gradient(135deg, #B91C1C 0%, #7F1D1D 100%)',
              },
            }}
          >
            Back to home
          </Button>
        </Paper>
      </Container>
    </Box>
  );
};

export default NotFound;
